
import React, { useState, useEffect } from "react";

import jwt from 'jwt-decode';
import { GET_APPLICATION_LIST, GET_ALL_STAKEHOLDERS, GET_USER_BY_ROLES, GET_STAKEHOLDER_DOCUMENTS } from '../../../common/URLs';
import back from '../../../images/backButton.png';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { ROLES } from '../../../common/constants';
import { loaderService } from "../../../common/custom-loader/loader-service";
import ScrutinyDetails from './scrutinyDetails';
import { Container, Row, Col, Stack, Table } from 'react-bootstrap';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { FileUpload, KeyboardArrowLeftRounded } from '@mui/icons-material'
import { Fab } from '@mui/material';
import { PROD } from '../../../common/constants';
import { Box, CardContent, Card, Typography, Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Link as RouterLink } from 'react-router-dom';
import Link from "@mui/material/Link";
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { FileUploadMUI } from "../../../common/fileUpload/fileUploadMUI";
import { lastFiveDigitsComparator } from "../../../common/commonFunction";
import apiClient from "../../../axios";

function VerifyStakeholderDocuments() {
    const [stakeholderDetails, setStakeholderDetails] = useState();
    const uuid = localStorage.getItem('uuid');
    useEffect(() => {
        getAllstakeholderDetails();
    }, []);

    const navigate = useNavigate();
    const location = useLocation();

    function getAllstakeholderDetails() {
        loaderService.showLoader();
        apiClient
            .post(GET_STAKEHOLDER_DOCUMENTS,
                {
                    "loginId": uuid,
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setStakeholderDetails(
                    response?.data?.stakeholderDocumentDetailsLst?.map((item, index) => {
                        const stakeholder = item?.stakeholderDetails || {};
 
                        return {
                            ...stakeholder,
                            documents: item?.stakholderDocumentDetails || [],
                            rowId: `${stakeholder?.id || "no-id"}-${stakeholder?.urn || "no-urn"}-${index}`,
                        };
                    }) || []
                );
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }

    const columns = [
        {
            field: 'urn', headerName: 'URN No', width: 150, sortComparator: (a, b) => lastFiveDigitsComparator(a, b),
            //   headerClassName: 'sticky-column',
        },
        {
            field: 'name',
            headerName: 'Applicant Name',
            width: 200,
            valueGetter: (params) =>
                params.row.category === "Grower" && params.row.subCategory === "Individual"
                    ? "-"
                    : (params.row.name || ""),
        },

        { field: 'stakeholderFirstName', headerName: 'First Name', width: 200, },
        { field: 'stakeholderMiddleName', headerName: 'Middle Name', width: 200, },
        { field: 'stakeholderLastName', headerName: 'Last Name', width: 200, },
        { field: 'idCardType', headerName: 'ID Proof Type', width: 150 },
        { field: 'idCardNumber', headerName: 'ID Proof No', width: 150 },
        {
            field: 'IDProof', headerName: 'ID Proof Document', width: 220,
            valueGetter: (params) =>
                (params.row.documents || [])
                    .filter((d) => d?.documentType === "IDProof")
                    .map((d) => d.documentName)
                    .join(", "),
            renderCell: (params) => {
                const tempArr = []
                const findItem = params.row.documents.find(item => item.documentType === "IDProof")
                if (findItem) {
                    tempArr.push({
                        id: null,
                        documentType: "IDProof",
                        documentName: findItem.documentName,
                        documentBlobName: findItem.documentBlobName,
                        documentPath: null,
                        documentContainerName: findItem.documetContainerName,
                        isActive: 1
                    })
                }
                return (
                    <FileUploadMUI key="IDProof"
                        documentList={tempArr}
                        documentType="IDProof"
                        stakeholderDetailId={params?.row?.id}
                        title=""
                        // stakeholderType="transporter"
                        isViewOnly="true"
                        isViewFile="true"
                    />
                );
            }
        },
        { field: 'bankAccountNumber', headerName: 'Bank Account Number', width: 200 },
        { field: 'bankAccountHolderName', headerName: 'Account Holder Name', width: 200 },
        { field: 'bankIfscCode', headerName: 'IFSC Code', width: 120 },
        { field: 'bankName', headerName: 'Bank Name', width: 200, },
        { field: 'bankBranch', headerName: 'Branch', width: 200 },
        {
            field: 'BankPassBook_CancelledCheque', headerName: 'Bank Proof Document', width: 220,
            valueGetter: (params) =>
                (params.row.documents || [])
                    .filter((d) => d?.documentType === "BankPassBook_CancelledCheque")
                    .map((d) => d.documentName)
                    .join(", "),
            renderCell: (params) => {
                const tempArr = []
                const findItem = params.row.documents.find(item => item.documentType === "BankPassBook_CancelledCheque")
                if (findItem) {
                    tempArr.push({
                        id: null,
                        documentType: "BankPassBook_CancelledCheque",
                        documentName: findItem.documentName,
                        documentBlobName: findItem.documentBlobName,
                        documentPath: null,
                        documentContainerName: findItem.documetContainerName,
                        isActive: 1
                    })
                }
                return (
                    <FileUploadMUI key="BankPassBook_CancelledCheque"
                        documentList={tempArr}
                        documentType="BankPassBook_CancelledCheque"
                        stakeholderDetailId={params?.row?.id}
                        title=""
                        // stakeholderType="transporter"
                        isViewOnly="true"
                        isViewFile="true"
                    />
                );
            }
        },
        { field: 'panNumber', headerName: 'PAN Number', width: 150 },
        {
            field: 'PANCard', headerName: 'PAN Document', width: 220,
            valueGetter: (params) =>
                (params.row.documents || [])
                    .filter((d) => d?.documentType === "PANCard")
                    .map((d) => d.documentName)
                    .join(", "),
            renderCell: (params) => {
                const docs = params.row?.documents || [];

                const landPicsDocs = docs
                    .filter((d) => d?.documentType === "PANCard")
                    .map((d) => ({
                        id: d.documentBlobName || null,
                        documentType: "PANCard",
                        documentName: d.documentName,
                        documentBlobName: d.documentBlobName,
                        documentPath: null,
                        documentContainerName: d.documetContainerName,
                        isActive: 1,
                    }));

                return (
                    <FileUploadMUI
                        key={`PANCard-${params.row?.id || params.row?.urn}`}
                        documentList={landPicsDocs}
                        documentType="PANCard"
                        stakeholderDetailId={params?.row?.id}
                        title=""
                        isViewOnly="true"
                        isViewFile="true"
                    />
                );
            },
        },
        { field: 'landName', headerName: 'Land Name', width: 180 },
        { field: 'geocodeLattitude', headerName: 'Latitude', width: 150 },
        { field: 'geocodeLaongitude', headerName: 'Longitude', width: 150 },
        {
            field: 'LandLeasedOwned', headerName: 'Land Document', width: 220,
            valueGetter: (params) =>
                (params.row.documents || [])
                    .filter((d) => d?.documentType === "LandLeasedOwned")
                    .map((d) => d.documentName)
                    .join(", "),
            renderCell: (params) => {
                const docs = params.row?.documents || [];

                const landPicsDocs = docs
                    .filter((d) => d?.documentType === "LandLeasedOwned")
                    .map((d) => ({
                        id: d.documentBlobName || null,
                        documentType: "LandLeasedOwned",
                        documentName: d.documentName,
                        documentBlobName: d.documentBlobName,
                        documentPath: null,
                        documentContainerName: d.documetContainerName,
                        isActive: 1,
                    }));

                return (
                    <FileUploadMUI
                        key={`LandLeasedOwned-${params.row?.id || params.row?.urn}`}
                        documentList={landPicsDocs}
                        documentType="LandLeasedOwned"
                        stakeholderDetailId={params?.row?.id}
                        title=""
                        isViewOnly="true"
                        isViewFile="true"
                    />
                );
            },
        },
        {
            field: 'LandPics', headerName: 'Land Photos', width: 220,
            valueGetter: (params) =>
                (params.row.documents || [])
                    .filter((d) => d?.documentType === "LandPics")
                    .map((d) => d.documentName)
                    .join(", "),
            renderCell: (params) => {
                const docs = params.row?.documents || [];

                const landPicsDocs = docs
                    .filter((d) => d?.documentType === "LandPics")
                    .map((d) => ({
                        id: d.documentBlobName || null,              // use blob as unique id 
                        documentType: "LandPics",
                        documentName: d.documentName,
                        documentBlobName: d.documentBlobName,
                        documentPath: null,
                        documentContainerName: d.documetContainerName,
                        isActive: 1,
                    }));

                return (
                    <FileUploadMUI
                        key={`LandPics-${params.row?.id || params.row?.urn}`}
                        documentList={landPicsDocs}
                        documentType="LandPics"
                        stakeholderDetailId={params?.row?.id}
                        title=""
                        isViewOnly="true"
                        isViewFile="true"
                    />
                );
            },
        }
    ];

    return (
        <>
            {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG47</p>}

            <Card>
                <CardContent>
                    <div>
                        <div style={{ display: "inline-flex" }}>
                            <Typography variant="h4" sx={{ mb: 2 }}>
                                <Fab component={RouterLink} to='../dashboard' size="small" aria-label="back" title='Back'>
                                    <KeyboardArrowLeftRounded />
                                </Fab>
                            </Typography>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <div className="hitDetailsText">Verify Stakeholder Documents</div>
                        </div>
                        {stakeholderDetails &&
                            <Box style={{ height: 500, width: '100%', marginTop: "2vh" }} >
                                <DataGrid
                                    rows={stakeholderDetails}
                                    columns={columns}
                                    pageSize={10}
                                    getRowId={(row) => row?.rowId}
                                    disableVirtualization
                                    disableColumnFilter={false}
                                    disableColumnMenu={true}
                                    disableDensitySelector={true}
                                    // getCellClassName={(params) => {
                                    //     return params.field === "urn" ? 'sticky-column' : '';
                                    // }}
                                    components={{ Toolbar: QuickSearchToolbar }}
                                />
                            </Box>}
                    </div>
                </CardContent>
            </Card>

        </>
    );
}
export default VerifyStakeholderDocuments;

